export const NONE_DETECTED = 'none detected';
